import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import { FiUpload } from "react-icons/fi";
import "./ApplyNow.css";
import { images } from "../../config/images";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Aos from "aos";
import { careerdetails, careerinquiry } from "../../config/services";
import { toast } from "react-toastify";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";

const ApplyNow = () => {
  const [errors, setErrors] = useState({});
  const [careerData, setCareerData] = useState({
    name: "",
    phone: "",
    qualification: "",
    address: "", // Corrected spelling
    email: "",
    comment: "",
    resume: null,
    experience: "",
  });

  const param = useParams();
  const location = useLocation();
  const careerId = location.state?.careerId;
  const [careerDetailsAPIData, setCareerDetailsAPIData] = useState([]);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    { label: "Career", url: "/career" },
    { label: careerDetailsAPIData[0]?.title },
  ];

  useEffect(() => {
    Aos.init({ duration: 2400 });
    fetchCareerDetails();
  }, []);

  const fetchCareerDetails = async () => {
    if (!careerId) return;
    try {
      const resp = await careerdetails({ params: { id: careerId } });
      if (resp.data.code === 200 || resp.data.code === 201) {
        setCareerDetailsAPIData(resp.data.responseBody);
      }
    } catch (error) {
      console.error("Error fetching career details:", error);
    }
  };

  const handleCareerData = (e) => {
    setErrors({ ...errors, [e.target.name]: "" });
    setCareerData({ ...careerData, [e.target.name]: e.target.value });
  };

  const handleFileChange = () => {
    const file = fileInputRef.current.files[0];
    setCareerData((prevData) => ({ ...prevData, resume: file }));
  };

  const handleApplyNow = async () => {
    const formData = new FormData();
    formData.append("career_id", careerId);
    Object.keys(careerData).forEach((key) => {
      formData.append(key, careerData[key]);
    });

    try {
      const resp = await careerinquiry(formData);
      if (resp.data.code === 200 || resp.data.code === 201) {
        toast.success(resp?.data?.message);
        setErrors({});
        setCareerData({
          name: "",
          phone: "",
          qualification: "",
          address: "",
          email: "",
          comment: "",
          experience: "",
          resume: null,
        });
      }
    } catch (error) {
      setErrors(error?.response?.data?.error || {});
      toast.error("Please Enter Data");
      console.error("Error submitting application:", error);
    }
  };

  return careerDetailsAPIData.length === 0 ? (
    <FullpageLoader />
  ) : (
    <div>
      <div className="about-us-container">
        <div className="molecule left">
          <img
            src={images.leftSpirrel}
            alt="Left Molecule"
            className="left-spinner"
          />
        </div>
        <div className="about-text">
          <h1>Career</h1>
          <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
        </div>
        <div className="molecule right">
          <img
            src={images.rightSpirrel}
            alt="Right Molecule"
            className="right-spinner"
          />
        </div>
      </div>
      <div className="pt-5 pb-5 contact-container common-sec">
        <div className="apply-now-form" data-aos="flip-left">
          <div className="apply-now-title">Send Us Your Detail</div>
          {careerDetailsAPIData.length > 0 && (
            <div>
              <h6 className="detail-title">
                {careerDetailsAPIData[0]?.title} -{" "}
                {careerDetailsAPIData[0]?.expection} Years Experience -{" "}
                {careerDetailsAPIData[0]?.background}
              </h6>
              {careerDetailsAPIData[0]?.description && (
                <p className="center-text">
                  {careerDetailsAPIData[0]?.description}
                </p>
              )}
            </div>
          )}
          <Grid container rowSpacing={3} className="apply-now-wrap">
            <Grid item xs={12} sm={12} md={6} lg={6} className="p-0">
              <div className="apply-now-inputs">
                <input
                  type="text"
                  placeholder="Your Name"
                  className="name-input"
                  name="name"
                  value={careerData.name}
                  onChange={handleCareerData}
                />
                {errors.name && <p className="error-valid">{errors.name}</p>}

                <input
                  type="tel"
                  placeholder="Phone"
                  className="name-input"
                  name="phone"
                  value={careerData.phone}
                  onChange={handleCareerData}
                  pattern="[0-9]*"
                  maxLength={10}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
                {errors.phone && <p className="error-valid">{errors.phone}</p>}

                <input
                  type="text"
                  placeholder="Qualification"
                  className="name-input"
                  name="qualification"
                  value={careerData.qualification}
                  onChange={handleCareerData}
                />
                {errors.qualification && (
                  <p className="error-valid">{errors.qualification}</p>
                )}

                <select
                  name="experience"
                  className="name-input"
                  onChange={handleCareerData}
                  value={careerData.experience}
                  style={{
                    color: careerData.experience ? "#000000" : "#aaaaaa",
                  }}
                >
                  <option value="">Select experience</option>
                  {Array.from({ length: 26 }, (_, index) => (
                    <option key={index} value={`${index} years`}>
                      {index} years Experience
                    </option>
                  ))}
                </select>
                {errors.experience && (
                  <p className="error-valid">{errors.experience}</p>
                )}

                <div className="input-icons">
                  <input
                    ref={fileInputRef}
                    className="input-file"
                    type="file"
                    accept=".doc,.pdf"
                    onChange={handleFileChange}
                  />
                  <div
                    className="custom-input-field-uploadCV"
                    onClick={() => fileInputRef.current.click()}
                  >
                    Upload your CV
                    <FiUpload className="icon-right-uploadCV" />
                  </div>
                  {careerData.resume && (
                    <p className="uploaded-file-name">
                      {careerData.resume.name}
                    </p>
                  )}
                  {errors.resume && (
                    <p className="error-valid">{errors.resume}</p>
                  )}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} className="p-0">
              <div className="apply-now-inputs">
                <input
                  type="email"
                  placeholder="Your Email"
                  className="name-input"
                  name="email"
                  value={careerData.email}
                  onChange={handleCareerData}
                />
                {errors.email && <p className="error-valid">{errors.email}</p>}

                <input
                  type="text"
                  placeholder="Address"
                  className="name-input"
                  name="address"
                  value={careerData.address}
                  onChange={handleCareerData}
                />
                {errors.address && (
                  <p className="error-valid">{errors.address}</p>
                )}

                <textarea
                  placeholder="Comment"
                  className="name-input comment"
                  name="comment"
                  value={careerData.comment}
                  onChange={handleCareerData}
                  rows="4"
                ></textarea>

                <div className="apply-now-form-actions">
                  <button
                    className="cancel-btn"
                    onClick={() => navigate("/career")}
                  >
                    Cancel
                  </button>
                  <button className="apply-now-button" onClick={handleApplyNow}>
                    Apply Now!
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default ApplyNow;
